import { render } from "./P_Bow.vue?vue&type=template&id=a73ee924&scoped=true"
import script from "./P_Bow.vue?vue&type=script&lang=js"
export * from "./P_Bow.vue?vue&type=script&lang=js"

import "./P_Bow.vue?vue&type=style&index=0&id=a73ee924&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a73ee924"]])

export default __exports__